import { LanguageCode } from '../types';

export interface SEOData {
  title: string;
  description: string;
  image?: string;
  type?: string;
  lang: LanguageCode;
  siteName: string;
  url?: string;
}

export function updateSEOMetadata({
  title,
  description,
  image = 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&q=80&w=1200',
  type = 'website',
  lang,
  siteName,
  url = typeof window !== 'undefined' ? window.location.href : '',
}: SEOData) {
  if (typeof document === 'undefined') return;

  // 1. Update Document Title
  document.title = title;

  // 2. Update HTML lang Attribute
  const langMap: Record<LanguageCode, string> = {
    TR: 'tr',
    KM: 'km',
    FR: 'fr',
    DE: 'de',
    EN: 'en',
  };
  document.documentElement.lang = langMap[lang] || 'tr';

  // Helper to update or inject <meta> tag
  const setMeta = (attrName: 'name' | 'property', attrValue: string, content: string) => {
    let el = document.querySelector<HTMLMetaElement>(`meta[${attrName}="${attrValue}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attrName, attrValue);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  // Helper to update or inject <link> tag
  const setLink = (rel: string, href: string) => {
    let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', rel);
      document.head.appendChild(el);
    }
    el.setAttribute('href', href);
  };

  const localeMap: Record<LanguageCode, string> = {
    TR: 'tr_TR',
    KM: 'km_IQ',
    FR: 'fr_FR',
    DE: 'de_DE',
    EN: 'en_US',
  };

  // Standard Meta Description
  setMeta('name', 'description', description);

  // Open Graph Tags
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:type', type);
  setMeta('property', 'og:image', image);
  setMeta('property', 'og:site_name', siteName);
  if (url) setMeta('property', 'og:url', url);
  setMeta('property', 'og:locale', localeMap[lang] || 'tr_TR');

  // Twitter Tags
  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', description);
  setMeta('name', 'twitter:image', image);

  // Canonical URL
  if (url) setLink('canonical', url);
}
